import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import logo from './logo.svg';
import { MenubarProps } from './menubar-types';
import { useStyles } from './menubar-styles';
import { useHistory } from 'react-router-dom';
import { useEventCallback } from '@eas/common-web';
import Hidden from '@material-ui/core/Hidden';
import ContainerLayout from '../container-layout/container-layout';

export function Menubar({ items, ActionComponent }: MenubarProps) {
  const classes = useStyles();

  const history = useHistory();

  const handleLogoClick = useEventCallback(() => {
    history.push('/');
  });

  return (
    <ContainerLayout className={classes.root}>
      <div className={classes.header}>
        <img src={logo} className={classes.logo} onClick={handleLogoClick} />

        <Hidden smDown>
          <MenuList className={classes.menu}>
            {items.map((item, i) => (
              <MenuItem
                key={i}
                onClick={item.onClick}
                className={classes.menuItem}
              >
                {item.label}
              </MenuItem>
            ))}
          </MenuList>
        </Hidden>

        {ActionComponent !== undefined && <ActionComponent />}
      </div>

      <Hidden mdUp>
        <MenuList className={classes.menu}>
          {items.map((item, i) => (
            <MenuItem
              key={i}
              onClick={item.onClick}
              className={classes.menuItem}
            >
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
      </Hidden>
    </ContainerLayout>
  );
}
